module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Folder-heart-44ea358b519c3d45c7393f3bc9ea5691.svg";